import { Component, CustomElement } from "../../core/CustomElement";

export interface CCCUserAvatarState {
  name: string;
  level: string;
  image: string;
  link: string;
}

@Component("ccc-user-avatar", {
  template: require("./template.html").default,
  style: require("./style.scss").default,
  observedAttributes: ["name", "level", "image", "link"],
})
export default class CCCUserAvatar extends CustomElement {
  state: CCCUserAvatarState = {
    name: "",
    level: "",
    image: "",
    link: "",
  };
  $nameContainer: HTMLElement = null;
  $levelContainer: HTMLElement = null;
  $imageContainer: HTMLElement = null;

  connectedCallback(): void {
    this.listenForClick();
  }

  listenForClick(): void {
    this.shadowDom
      .querySelector(".ccc-user-avatar")
      .addEventListener("click", () => {
        if (this.state.link === "") {
          const event = new CustomEvent("ccc-user-avatar-click", {
            detail: this.state,
          });
          console.debug("User Avatar", "Clicked", event);
          this.dispatchEvent(event);
        } else {
          // open link
          console.debug("User Avatar", "Go to page", this.state.link);
          window.location.href = this.state.link;
        }
      });
  }

  watchName(): void {
    if (this.$nameContainer === null)
      this.$nameContainer = this.shadowDom.querySelector(
        ".ccc-user-avatar-name"
      );
    console.debug("Debugging watch name", this.state.name, this.$nameContainer);
    if (this.state.name !== "") {
      this.$nameContainer.innerHTML = `<span>${this.state.name}</span>`;
    }
  }
  watchImage(): void {
    if (this.$imageContainer === null)
      this.$imageContainer = this.shadowDom.querySelector(
        ".ccc-user-avatar-image"
      );
    console.debug(
      "Debugging watch image",
      this.state.image,
      this.$imageContainer
    );
    if (this.state.image !== "") {
      this.$imageContainer.style.backgroundImage = `url("${this.state.image}")`;
    }
  }
  watchLevel(): void {
    if (this.$levelContainer === null)
      this.$levelContainer = this.shadowDom.querySelector(
        ".ccc-user-avatar-level"
      );
    if (this.state.level !== "") {
      const levelClass =
        "level-" + this.state.level.toLocaleLowerCase().replace(" ", "-");
      this.$levelContainer.innerHTML = `<span class="${levelClass}">${this.state.level}</span>`;
    }
  }
}
